import React from 'react';
import $ from 'jquery';
import Display from '../parts/display';
import Video from 'react-html5video';
import Scroll, {Element, scroller}  from 'react-scroll';

class PortfolioItem extends React.Component {
	constructor() {
		super();
		this.state = {
		};
		this.showImages = this.showImages.bind(this);
		this.showVideos = this.showVideos.bind(this);
		this.scrollToInfo = this.scrollToInfo.bind(this);
		this.scrollToTop = this.scrollToTop.bind(this);
	}
	componentDidMount(){$('.beta-tag').hide();}
	componentWillUnmount(){$('.beta-tag').show();}
	showImages(image, index){
		return <div key={index} className="portfolio-image">
			<img src={image.image} />
			<p className="caption">{image.description}</p>
		</div>
	}
	showVideos(video, index){
		return <div className="portfolio-video" key={index}>
				<Video controls poster={video.image}>
					<source src={video.video} type="video/mp4" />
				</Video>
				<p className="caption">{video.title}</p>
			</div>
	}
	scrollToInfo(){
		scroller.scrollTo('scrollToText', {
			duration: 1000,
			delay: 0,
			smooth: true,
			containerId: 'portfolio-item'
		});
	}
	scrollToTop(){
		scroller.scrollTo('scrollToTop', {
			duration: 1000,
			delay: 0,
			smooth: true,
			containerId: 'portfolio-item'
		});
	}
	render() {

		return (
			<Display if={this.props.portfolio}>
			<div className="services-page animated fadeIn portfolio-item">
				<Element name="scrollToTop"/>
				<div className="close" onClick={this.props.onClose}></div>
					<div className="container">
						<div className="row">
							<div className="header">
								<Display if={this.props.portfolio? this.props.portfolio.client.branding? this.props.portfolio.client.branding : false : false} className="col-md-12 col-xs-12 client-logo">
									<img src={this.props.portfolio? this.props.portfolio.client.branding : ''} />
								</Display>
								<div className="col-md-6 col-xs-12 title-block">
									<p className="client-name" dangerouslySetInnerHTML={{__html: this.props.portfolio? this.props.portfolio.client.title: ''}}></p>
									<h2 className="project-name"  dangerouslySetInnerHTML={{__html:this.props.portfolio? this.props.portfolio.title.rendered: '' }}></h2>
								</div>
								<div className="col-md-6 col-xs-12  description-block">

									<div className="project-description">
										<div dangerouslySetInnerHTML={{__html:this.props.portfolio? this.props.portfolio.content.rendered: ''}}></div>
										<Display if={this.props.portfolio? this.props.portfolio.acf.information_left || this.props.portfolio.acf.information_right ? true: false:false}>
											<p className="read-more-portfolio" onClick={this.scrollToInfo}>Read more</p>
										</Display>
									</div>
								</div>
							</div>

							<hr />
							{this.props.portfolio? this.props.portfolio.acf.videos?  this.props.portfolio.acf.videos.map(this.showVideos): '': ''}
							{this.props.portfolio? this.props.portfolio.acf.images? this.props.portfolio.acf.images.map(this.showImages): '' : ''}
							<Display if={this.props.displayScroll}><div className="scroll-to-top animated fadeIn" onClick={this.scrollToTop}><span>Back to top</span></div></Display>
							<Display if={this.props.portfolio? this.props.portfolio.acf.information_left || this.props.portfolio.acf.information_right : false}>
								<Element name="scrollToText"/>
								<div className="portfolio-info">
									<div className="information">
										<div className="col-md-6 info-left" dangerouslySetInnerHTML={{__html: this.props.portfolio? this.props.portfolio.acf.information_left: ''}}></div>
										<div className="col-md-6 info-right" dangerouslySetInnerHTML={{__html: this.props.portfolio? this.props.portfolio.acf.information_right: ''}}></div>
									</div>
								</div>
							</Display>
						</div>
					</div>
				</div>
			</Display>
		);
	}
}

export default PortfolioItem;


/** WEBPACK FOOTER **
 ** ./src/js/components/portfolio/portfolioItem.js
 **/